import { PartnerAnalysisGroup4 } from '../../entities/control-tables/partner-analysis-group4';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class PartnerAnalysisGroup4Request extends BaseRequest {

    partnerAnalysisGroup4 : PartnerAnalysisGroup4

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.partnerAnalysisGroup4 = new PartnerAnalysisGroup4()
  }
}